export function getTextWithoutLineBreaks(text: string) {
    return text.replace(/\s+/g, ' ').trim();
}
